import { useMemo } from "react";
import {
  ProductReviewSummary,
  ReviewsResult,
} from "../../../graphql/operations";
import styles from "./ProductCard.module.scss";

type ReviewRatingProps = {
  reviewSummary: Pick<ProductReviewSummary, "average" | "numReviews">;
};

export function ReviewRating(
  props:
    | ReviewRatingProps
    | {
        reviews: Pick<ReviewsResult, "avgStars" | "totalRecords">;
      }
) {
  // accept either the new Review Summary setup, or the existing Reviews setup

  const normalizedProps = useMemo(
    () =>
      "reviews" in props && !!props.reviews
        ? {
            reviewSummary: {
              numReviews: props.reviews.totalRecords,
              average: props.reviews.avgStars,
            },
          }
        : props,
    [props]
  ) as ReviewRatingProps;

  return <_ReviewRating {...normalizedProps} />;
}

function _ReviewRating({
  reviewSummary: { average, numReviews },
}: ReviewRatingProps) {
  if (numReviews === 0) return null;

  const displayRating = average.toFixed(2);

  return (
    <>
      <span className={styles.ProductCardRating}>
        ★ <b style={{ color: "#000" }}>{displayRating}</b>
      </span>{" "}
      ({numReviews})
    </>
  );
}
